import { Link, useNavigate } from "react-router";

import { Button } from "@/components/ui/button";
import { useLogout, useMe } from "@/lib/api";
import { logger } from "@/lib/logger";

/**
 * Shared top navigation chrome for authenticated pages: brand, Profile/Admin
 * links, and sign-out. Extracted from the old scaffold HomePage so the Cases
 * Library (now the landing page) keeps the same navigation.
 */
export function AppHeader() {
  const navigate = useNavigate();
  const logoutMutation = useLogout();
  const { data: me } = useMe();

  const handleLogout = async () => {
    logger.debug("[auth]", "signing out from app header");
    await logoutMutation.mutateAsync();
    navigate("/login");
  };

  return (
    <header className="border-border/80 bg-card/90 sticky top-0 z-10 flex items-center justify-between border-b px-6 py-3 backdrop-blur-sm">
      <Link to="/" className="flex items-center gap-3">
        <img
          src="/brand/logo.png"
          alt="Board of Innovation"
          className="h-7 w-auto object-contain"
        />
        <p className="font-heading text-primary text-lg font-bold">Case Study Generator</p>
      </Link>
      <div className="flex items-center gap-2">
        <Link to="/profile">
          <Button variant="ghost" size="sm">
            Profile
          </Button>
        </Link>
        {me?.role === "admin" && (
          <>
            <Link to="/admin/users">
              <Button variant="ghost" size="sm">
                Admin
              </Button>
            </Link>
            <Link to="/admin/activity">
              <Button variant="ghost" size="sm">
                Activity
              </Button>
            </Link>
          </>
        )}
        <Button variant="outline" size="sm" onClick={handleLogout}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
